import { render, staticRenderFns } from "./uploadContentsChat.vue?vue&type=template&id=0fbc7332&scoped=true&"
import script from "./uploadContentsChat.vue?vue&type=script&lang=js&"
export * from "./uploadContentsChat.vue?vue&type=script&lang=js&"
import style0 from "./uploadContentsChat.vue?vue&type=style&index=0&id=0fbc7332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc7332",
  null
  
)

export default component.exports